/**
 * ModePicker — the "course assistance mode" dropdown (lesson plan /
 * cheat sheet / rubric / etc.). Split out from the old
 * SubjectCourseAssistanceSelector when the subject column became a
 * data-driven AgentPicker; the mode column is unrelated and keeps
 * working as before.
 */
import { useTranslation } from "react-i18next";
import type { CourseAssistanceMode } from "./types";

interface Props {
  modes: readonly CourseAssistanceMode[];
  modeId: CourseAssistanceMode["id"];
  onModeChange: (modeId: CourseAssistanceMode["id"]) => void;
}

export function ModePicker({ modes, modeId, onModeChange }: Props) {
  const { t } = useTranslation();
  return (
    <label className="flex items-center gap-2 text-xs text-slate-600">
      <span>{String(t("workbench.pickers.mode"))}</span>
      <select
        value={modeId}
        onChange={(e) =>
          onModeChange(e.target.value as CourseAssistanceMode["id"])
        }
        className="rounded border border-slate-200 bg-white px-2 py-1 text-xs text-slate-800 focus:border-sky-300 focus:outline-none"
      >
        {modes.map((mode) => (
          <option key={mode.id} value={mode.id}>
            {t(`workbench.modes.${mode.id}`, { defaultValue: mode.label })}
          </option>
        ))}
      </select>
    </label>
  );
}
